export {
  IPHONE_SAFARI_BOTTOM_BAR,
  IPHONE_X_SAFARI_BOTTOM_BAR,
  IPHONE_KEYBOARD_REJECT_OFFSET,
  IOS_NO_KEYBOARD_ALLOWED_OFFSET,
  detectIOS,
  isIPad,
  isIPhone,
  isIOS,
  isIPadOS,
  iosMajor,
  iosMinor,
  isWKWebView,
  isScrollBasedViewport,
  isIPhoneX,
  isIOSChrome,
  isLandscapePhone,
  checkIPadOS,
} from './IOSDetections.ts';

export { hasMouse, hasHover, hasTouchEvents, hasTouch } from './InputUtils.ts';

export { isRetina } from './retina.ts';
